import type { ProfileConfig } from "@worker/config-schema";
import { el } from "../../lib/dom";
import { widgetShell, fetchWidget } from "./base";

type LastfmWidget = Extract<ProfileConfig["widgets"][number], { type: "lastfm" }>;

type LastfmData = {
  user: string;
  track?: {
    name: string;
    artist: string;
    album: string;
    image: string;
    nowPlaying: boolean;
    url: string;
  } | null;
  unconfigured?: boolean;
};

export function mountLastfmWidget(cfg: LastfmWidget): HTMLElement {
  const shell = widgetShell({ kind: "lastfm", title: "Last.fm", accent: "#d51007" });
  shell.setLoading();

  const controller = new AbortController();
  shell.root.addEventListener("bio:teardown", () => controller.abort());

  const render = async () => {
    const env = await fetchWidget<LastfmData>("lastfm", { u: cfg.username }, { signal: controller.signal });
    if (!env.ok || !env.data) return shell.setError(env.error ?? "unavailable");
    const d = env.data;
    if (d.unconfigured) return shell.setError("requires LASTFM_API_KEY");
    if (!d.track) return shell.setError("no recent plays");
    shell.body.innerHTML = "";
    const row = el("a", {
      class: "widget-lastfm__row",
      href: d.track.url,
      target: "_blank",
      rel: "noopener noreferrer",
    });
    if (d.track.image) {
      row.append(el("img", { class: "widget-lastfm__cover", src: d.track.image, alt: "", draggable: false }));
    }
    const info = el("div", { class: "widget-lastfm__info" }, [
      el("div", { class: "widget-lastfm__title" }, [d.track.name]),
      el("div", { class: "widget-lastfm__artist" }, [d.track.artist]),
    ]);
    if (d.track.nowPlaying) {
      info.append(el("span", { class: "widget-lastfm__now" }, ["▸ now playing"]));
    }
    row.append(info);
    shell.body.append(row);
  };

  void render();
  const interval = window.setInterval(render, 60_000);
  shell.root.addEventListener("bio:teardown", () => window.clearInterval(interval));

  return shell.root;
}
